export const config = {
  title: "Reaffirm Roofing | Trusted Roofing Experts in Houston, TX",
  meta: {
    description:
      "Reaffirm Roofing provides high-quality, reliable roofing services to homeowners and businesses in Houston, TX. Licensed, insured, and customer-focused.",
    keywords: [
      "Houston roofing company",
      "Reaffirm Roofing",
      "roof repair Houston",
      "roof replacement",
      "licensed roofer Texas"
    ],
    author: "Reaffirm Roofing",
    canonicalUrl: "https://reaffirmroofing.com/",
  },
  sections: {
    header: {
      businessName: "Reaffirm Roofing",
    },
    sectionB: {
      heroTitle: "Reaffirm Roofing",
      heroSubtitle: "Trusted Roofing Experts Serving Houston, TX",
      learnAboutText: "Request a Quote",
      phoneNumber: "8327855212",
      phoneLabel: "(832) 785-5212",
      heroBackgroundImage:
        "https://reaffirmroofing.com/wp-content/uploads/2025/07/IMG_0532.png",
      cardData: [
        {
          title: "Residential Roofing",
          description: "Protect your home with our reliable roofing services.",
        },
        {
          title: "Commercial Roofing",
          description: "Durable roofing solutions for businesses in Houston.",
        },
        {
          title: "Roof Repair",
          description: "Quick and effective repairs for leaks, damage, and wear.",
        },
      ],
      description:
        "Reaffirm Roofing is a top-rated roofing company in Houston, TX, providing expert residential and commercial roofing services with a commitment to excellence and safety.",
    },
    sectionC: {
      servicesTitle: "Our Roofing Services",
      servicesDescription:
        "We deliver dependable and high-quality roofing services tailored to meet your needs, whether for your home or business.",
      cards: [
        {
          title: "New Roof Installation",
          description: "Expertly installed roofs using premium materials.",
          imageSrc: "https://reaffirmroofing.com/wp-content/uploads/2025/07/IMG_0024.png",
          imageAlt: "New Roof Installation",
        },
        {
          title: "Roof Repairs",
          description: "We fix leaks, storm damage, and more.",
          imageSrc: "https://reaffirmroofing.com/wp-content/uploads/2025/07/IMG_0021.png",
          imageAlt: "Roof Repair",
        },
        {
          title: "Insurance Claims Assistance",
          description: "We help guide you through the insurance process.",
          imageSrc: "https://reaffirmroofing.com/wp-content/uploads/2025/07/IMG_0229.png",
          imageAlt: "Insurance Help",
        },
      ],
      otherServicesTitle: "Why Choose Reaffirm Roofing?",
      otherServicesList: [
        "Locally Owned & Operated",
        "Licensed & Insured",
        "Honest Pricing",
        "Free Roof Inspections",
        "Experienced Crews",
      ],
    },
    sectionD: {
      aboutTitle: "About Reaffirm Roofing",
      aboutImage: {
        src: "https://reaffirmroofing.com/wp-content/uploads/2025/07/01.jpg",
        alt: "Reaffirm Roofing Team",
      },
      aboutText: [
        "Reaffirm Roofing is your local Houston roofer with a reputation for quality craftsmanship, honest service, and long-lasting results.",
        "We work closely with homeowners and businesses to ensure their roofs are safe, secure, and built to last.",
      ],
    },
    sectionE: {
      profileImage: "https://reaffirmroofing.com/wp-content/uploads/2025/07/final-logo-rr.png",
      profileAlt: "Reaffirm Roofing Logo",
      businessName: "Reaffirm Roofing",
      contact: {
        phone: "8327855212",
        phoneLabel: "(832) 785-5212",
        email: "jcastillo@reaffirmroofing.com",
        website: "https://reaffirmroofing.com/",
        address: "Houston, TX, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Houston, TX, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d110578.25046497384!2d-95.4694045!3d29.8173649!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640bf1be3c8d3b5%3A0xc7cfb79d865f739f!2sHouston%2C%20TX!5e0!3m2!1sen!2sus!4v1710000000000",
    },
  },
};

export default config;
